export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-qa.sp.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-qa.sp.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-qa.sp.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/sp-avwave-qa/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
